import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { Color, CommonStyles, CommonProperties } from '../../styles';
import { REBOOK_ENABLED } from '../../config/env';
import { useSelector } from 'react-redux';
import { selectCheckedRebookPassengers } from '../../store/selectors/mytrips.selector';
const SearchTripOptionsDisplay = (props) => {
  const { dominantSearchType, hasHotel, hasCar, airClassType, tripOptions } = props;
  const { noOfCars, noOfRooms, persons } = tripOptions;
  const noOfPersons = persons.noOfAdults + persons.noOfSeniors + persons.infants.length;
  const passengers = useSelector(selectCheckedRebookPassengers);
  const length = hasCar && hasHotel ? 2 : hasCar || hasHotel ? 3 : 4;

  return (
    <View style={styles.tripOptionsContainer}>
      <View style={styles.flewRow}>
        <Icon size={28} name="person" style={CommonStyles.mr3} color={Color.text.low} />
        <BaseText style={CommonStyles.h2}>
          {REBOOK_ENABLED ? passengers.length : noOfPersons}
        </BaseText>
      </View>
      {hasHotel && (
        <View style={[styles.flewRow, styles.borderLeft]}>
          <Icon size={28} name="hotel" style={CommonStyles.mx3} color={Color.text.low} />
          <BaseText style={CommonStyles.h2}>{REBOOK_ENABLED ? 1 : noOfRooms}</BaseText>
        </View>
      )}
      {hasCar && (
        <View style={[styles.flewRow, styles.borderLeft]}>
          <Icon size={28} name="car" style={CommonStyles.mx3} color={Color.text.low} />
          <BaseText style={CommonStyles.h2}>{REBOOK_ENABLED ? 1 : noOfCars}</BaseText>
        </View>
      )}
      {dominantSearchType === 'air' && (
        <View style={[styles.flewRow, styles.borderLeft]}>
          <Icon size={28} name="plane" style={CommonStyles.mx3} color={Color.text.low} />
          <BaseText style={CommonStyles.h2}>
            {airClassType?.substring(0, length).toUpperCase()}
          </BaseText>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  tripOptionsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.px3,
  },
  flewRow: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    ...CommonProperties.py3,
  },
  borderLeft: {
    borderLeftWidth: 0.7,
    borderLeftColor: 'rgba(0,0,0,.2)',
  },
});

export default memo(SearchTripOptionsDisplay);
